import { useEffect } from 'react';
import { useAppDispatch } from '@/shared/lib/hooks/useAppDispatch';
import { useAppSelector } from '@/shared/lib/hooks/useAppSelector';
import { fetchQuestionnaire } from '@/features/questionnaire/model/questionnaireSlice';

export const useSurvey = () => {
    const dispatch = useAppDispatch();
    const data = useAppSelector((state) => state.questionnaire.data);
    const loading = useAppSelector((state) => state.questionnaire.loading);
    const error = useAppSelector((state) => state.questionnaire.error);

    useEffect(() => {
        if (!data) {
            dispatch(fetchQuestionnaire());
        }
    }, [dispatch, data]);

    return { survey: data, loading, error };
};
